<template>
    <v-row class="d-flex align-center">
        <v-col cols="4">
            <text-field
                :value="controller.model.getTemplateName()"
                :label="$t('Template name')"
                :disabled="!controller.model.canEditTemplate()"
                :error-messages="controller.model.getErrors().template_name"
                test-id="email-template-dialog-template-name"
                @input="controller.setTemplateName($event)"
            />
        </v-col>
        <v-col cols="8" class="pb-2 pt-1">
            <checkbox
                :value="controller.model.getIsPublic()"
                :label="$t('Public')"
                :disabled="controller.model.isPublicDisabled()"
                :error-messages="controller.model.getErrors().is_public"
                @change="controller.setIsPublic($event)"
            />
        </v-col>
    </v-row>
</template>

<script>
import Controller from "./controller"

export default {
    name: "EditTemplateOptions",
    props: {
        controller: {
            type: Controller,
            required: true
        },
    }
}
</script>
